// extracted by mini-css-extract-plugin
export default {"mainContainer":"FAQ_mainContainer__09f5K","header":"FAQ_header__7sPPu","faqSection":"FAQ_faqSection__X8JzP"};